import dompurify from 'dompurify';

/**
 * Strips anything that could run in the reader's browser from HTML another user wrote. Every place
 * that renders or edits such HTML goes through this one call, so the allowed markup stays the same
 * whether it is shown through SafeHtml or loaded into Quill.
 */
export const sanitizeHtml = (html: string | null | undefined): string => dompurify.sanitize(html ?? '');
